var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uploadMaterial" }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("img", {
        attrs: { src: require("../../../../static/images/close.png") },
        on: {
          click: function($event) {
            return _vm.close()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "material-site" },
      [
        _c(
          "el-form",
          { ref: "materialForm", attrs: { model: _vm.materialForm } },
          [
            [
              _c(
                "div",
                { staticClass: "sub" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "科目:", "label-width": "53px" } },
                    [
                      _c("el-input", {
                        attrs: {
                          readonly: "",
                          disabled: "",
                          placeholder: "科目"
                        },
                        model: {
                          value: _vm.materialObjData.name,
                          callback: function($$v) {
                            _vm.$set(_vm.materialObjData, "name", $$v)
                          },
                          expression: "materialObjData.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "知识点:", prop: "taskName" } },
                    [
                      _c("el-cascader", {
                        ref: "cascader",
                        attrs: {
                          placeholder: "全部",
                          options: _vm.cascaderOptions,
                          props: {
                            checkStrictly: true,
                            expandTrigger: "hover"
                          },
                          filterable: "",
                          clearable: "",
                          "show-all-levels": "",
                          "popper-class": "mycascader"
                        },
                        model: {
                          value: _vm.selectedOptions,
                          callback: function($$v) {
                            _vm.selectedOptions = $$v
                          },
                          expression: "selectedOptions"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "选择文件:", prop: "materialUpload" } },
              [
                _c(
                  "el-upload",
                  {
                    ref: "addUpload",
                    attrs: {
                      action: _vm.materialForm.upload.url,
                      data: _vm.materialForm.upload.data,
                      headers: _vm.headers,
                      "show-file-list": false,
                      "with-credentials": true,
                      "on-success": _vm.handleAvatarSuccess,
                      "on-error": _vm.handleAvatarError,
                      "before-upload": _vm.beforeAvatarUpload,
                      "on-progress": _vm.uploadProgress,
                      "on-preview": _vm.handlePreview,
                      multiple: ""
                    }
                  },
                  [
                    _c("div", { staticClass: "el-upload__text" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/image/sources/add.png"),
                          alt: ""
                        }
                      })
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-p" }, [
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [
                  _c("span", [_vm._v("格式说明：")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "tis-p" }, [
                    _vm._v("文档：支持doc.docx.ppt.pptx.pdf.xlsx格式 "),
                    _c("br"),
                    _c("span", [_vm._v(" 图片：支持png.jpg.jpeg格式10M以内")]),
                    _vm._v(" "),
                    _c("br"),
                    _c("span", [
                      _vm._v("视频：支持asx.asf.mpg.3gp.mp4.mov.avi.flv格式")
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [_vm._v(" 音频：支持mp3格式 ")]),
                    _vm._v(" "),
                    _c("br"),
                    _c("span", [_vm._v("课件包：支持zip格式")])
                  ])
                ]
              )
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "uploadList" }, [
          _c(
            "div",
            { staticClass: "uploadCompleted" },
            [
              _c(
                "el-button",
                {
                  class: ["upload", _vm.isUploadingChecked ? "active" : ""],
                  attrs: { round: "", size: "mini" },
                  on: { click: _vm.uploading }
                },
                [_vm._v("正在上传")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  class: [
                    "upload",
                    _vm.isUploadCompletedChecked ? "active" : ""
                  ],
                  attrs: { round: "", size: "mini" },
                  on: { click: _vm.uploadCompleted }
                },
                [_vm._v("上传完成")]
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v("共"),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.showUploadFileList.filter(function(x) {
                        return x.state == _vm.showState
                      }).length
                    )
                  )
                ]),
                _vm._v("条")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.isUploadingChecked
            ? _c(
                "div",
                {
                  style:
                    "height:" +
                    (_vm.windowHeight - 210) +
                    "px; overflow-y: auto;"
                },
                _vm._l(
                  _vm.showUploadFileList.filter(function(x) {
                    return x.state != "已完成"
                  }),
                  function(site, index) {
                    return _c(
                      "el-row",
                      { key: index },
                      [
                        _c(
                          "el-col",
                          {
                            attrs: { span: 5, title: _vm.materialObjData.name }
                          },
                          [
                            _c("span", [_vm._v("科目")]),
                            _vm._v(_vm._s(_vm.materialObjData.name))
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5, title: site.materialName } },
                          [
                            _c("span", [_vm._v("素材目录")]),
                            _vm._v(_vm._s(site.materialName))
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 5, title: site.name } }, [
                          _c("img", { attrs: { src: site.img, alt: "" } }),
                          _vm._v(_vm._s(site.name))
                        ]),
                        _vm._v(" "),
                        site.state != "已完成"
                          ? _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("computeFileSize")(site.size)
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 16 } },
                                  [
                                    _c("el-progress", {
                                      attrs: {
                                        percentage: site.percentage,
                                        color: "#409eff",
                                        "stroke-width": 10
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        site.state == "上传中"
                          ? _c("el-col", { attrs: { span: 4 } }, [
                              _c("b", [_c("i"), _vm._v(_vm._s(site.state))]),
                              _c("em"),
                              _c("strong", {
                                staticClass: "imgPicDel",
                                on: {
                                  click: function($event) {
                                    return _vm.uploadDel(site)
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        site.state == "上传失败"
                          ? _c("el-col", { attrs: { span: 4 } }, [
                              _c("b", { staticStyle: { color: "#F56C6C" } }, [
                                _c("i", {
                                  staticStyle: { background: "#F56C6C" }
                                }),
                                _vm._v(_vm._s(site.state))
                              ]),
                              _c("em", {
                                staticClass: "imgPic",
                                on: {
                                  click: function($event) {
                                    return _vm.reloadUpload(site)
                                  }
                                }
                              }),
                              _c("strong", {
                                staticClass: "imgPicDel",
                                on: {
                                  click: function($event) {
                                    return _vm.uploadDel(site)
                                  }
                                }
                              })
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  }
                ),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUploadCompletedChecked
            ? _c(
                "div",
                {
                  style:
                    "height:" +
                    (_vm.windowHeight - 210) +
                    "px; overflow-y: auto;"
                },
                _vm._l(
                  _vm.showUploadFileList.filter(function(x) {
                    return x.state == "已完成"
                  }),
                  function(site, index) {
                    return _c(
                      "el-row",
                      { key: index },
                      [
                        _c(
                          "el-col",
                          {
                            attrs: { span: 5, title: _vm.materialObjData.name }
                          },
                          [
                            _c("span", [_vm._v("科目")]),
                            _vm._v(_vm._s(_vm.materialObjData.name))
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5, title: site.materialName } },
                          [
                            _c("span", [_vm._v("素材目录")]),
                            _vm._v(_vm._s(site.materialName))
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 5, title: site.name } }, [
                          _c("img", { attrs: { src: site.img, alt: "" } }),
                          _vm._v(_vm._s(site.name))
                        ]),
                        _vm._v(" "),
                        site.state == "已完成"
                          ? _c(
                              "el-col",
                              { attrs: { span: 3 } },
                              [
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("computeFileSize")(site.size)
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        site.state == "已完成"
                          ? _c("el-col", { attrs: { span: 4 } }, [
                              _c("b", [_c("i"), _vm._v(_vm._s(site.state))]),
                              _c(
                                "span",
                                {
                                  staticClass: "dataTime",
                                  attrs: { title: site.createTime }
                                },
                                [_vm._v(_vm._s(site.createTime))]
                              ),
                              _c("em"),
                              _c("strong", {
                                staticClass: "imgPicDel",
                                on: {
                                  click: function($event) {
                                    return _vm.uploadDel(site)
                                  }
                                }
                              })
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  }
                ),
                1
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("i"), _vm._v("上传素材")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87fbd30a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87fbd30a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/uploadMaterial.vue
// module id = null
// module chunks = 